import {useState} from "react";
import PrintState from "./interface/PrintState";
import PrintController from "./controller/printController";
import {useTranslation} from "react-i18next";

export default function PrintForm() {
    const {t} = useTranslation();
    const [state, setState] = useState<PrintState>({
        error: false,
        ip: "",
        port: "",
        name: "",
        message: "",
    })

    return (
        <form className="add-discount-form" onSubmit={e => new PrintController(state, setState).addPrinter(e)}>
            <h3>{t("setting.addNetworkPrinter")}</h3>
            <div className="inputs-container">
                <label>
                    <input type="text"
                           placeholder={t("setting.printerName")}
                           value={state.name}
                           inputMode={'text'}
                           onChange={e => setState({...state, name: e.target.value})}/>
                </label>
                <label>
                    <input type="text"
                           placeholder={t("setting.printerIP")}
                           value={state.ip}
                           inputMode={'numeric'}
                           onChange={e => setState({...state, ip: e.target.value})}/>
                </label>
                <label className={'price-discount'}>
                    <input type="number" value={state.port}
                           placeholder={t("setting.printerPort")}
                           onChange={e => setState({...state, port: e.target.value})}/>
                </label>
                <button type="submit" onClick={e => new PrintController(state, setState).addPrinter(e)}>
                    {t("add")}
                </button>
            </div>
            {state.error ? <p className={'error'}>{state.message}</p> : null}
        </form>
    );
}